// hooks/useConsultants.js
import { useQuery, keepPreviousData } from "@tanstack/react-query"
import { API } from "config"

const buildQueryString = (page, term, activeMonthStatus) => {
    const params = new URLSearchParams()
    params.set("page", String(page))
    if (term && String(term).trim()) params.set("term", String(term).trim())
    if (activeMonthStatus != null) params.set("active_month_status", String(activeMonthStatus))
    return params.toString()
}

const fetchConsultants = async (page, term, activeMonthStatus, signal) => {
    const qs = buildQueryString(page, term, activeMonthStatus)
    const { data } = await API.get(`/consultants/list?${qs}`, { signal })
    return data
}

const useConsultants = (page = 1, term = null, activeMonthStatus = null) =>
    useQuery({
        queryKey: ["consultants", { page, term, activeMonthStatus }],
        queryFn: ({ signal }) => fetchConsultants(page, term, activeMonthStatus, signal),
        placeholderData: keepPreviousData,
        staleTime: 60 * 60 * 1000,       // 1h
        gcTime: 24 * 60 * 60 * 1000,     // 24h
        refetchOnWindowFocus: false,
        retry: 2,
    })

export default useConsultants
